import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Clean%20minimalist%20abstract%20composition%20with%20soft%20warm%20coral%20and%20cream%20tones%2C%20gentle%20geometric%20shapes%20floating%20in%20airy%20composition%2C%20modern%20editorial%20style%20with%20organic%20textures%2C%20light%20airy%20background%20suitable%20for%20fashion%20shopping%20website%20hero%20section%2C%20subtle%20gradients%20and%20soft%20atmospheric%20lighting%2C%20elegant%20minimal%20design%20aesthetic%20with%20warm%20beige%20and%20terracotta%20undertones&width=1600&height=900&seq=vigorbuy-hero-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-400"></div>
              <span className="text-xs font-medium text-background-50/90">Updated for 2026</span>
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
              Vigorbuy Spreadsheet
              <br />
              <span className="text-accent-300">The Complete Guide</span>
            </h1>
            <p className="text-base md:text-lg text-background-50/80 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-8">
              Discover organized product information, shopping guides, category lists and comparison tools designed to help you research products faster and shop smarter.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-400 transition-all whitespace-nowrap"
              >
                Vigorbuy Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl text-sm font-semibold bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 hover:bg-background-50/25 transition-all whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-shopping-cart-line"></i>
              </a>
              <Link
                to="/article/vigorbuy-spreadsheet-complete-guide"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl text-sm font-medium text-background-50/80 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                Read Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8 justify-center lg:justify-start">
              {['Updated Resources', 'Organized Product Data', 'Beginner Friendly', 'Secure Guide'].map((badge) => (
                <div key={badge} className="flex items-center gap-1.5 text-xs text-background-50/70">
                  <i className="ri-check-line text-accent-400 text-sm"></i>
                  {badge}
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="relative bg-background-50/10 backdrop-blur-sm rounded-2xl border border-background-50/15 p-5 overflow-hidden">
              <div className="flex items-center gap-2 mb-4">
                <div className="flex gap-1.5">
                  <div className="w-2.5 h-2.5 rounded-full bg-red-400/60"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-yellow-400/60"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-green-400/60"></div>
                </div>
                <span className="text-xs text-background-50/50 ml-2">vigorbuy-spreadsheet-2026</span>
              </div>
              <table className="w-full text-left">
                <thead>
                  <tr className="border-b border-background-50/10">
                    <th className="py-2 px-2 text-xs font-semibold text-background-50/60 uppercase tracking-wider">Product</th>
                    <th className="py-2 px-2 text-xs font-semibold text-background-50/60 uppercase tracking-wider">Category</th>
                    <th className="py-2 px-2 text-xs font-semibold text-background-50/60 uppercase tracking-wider">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { name: 'Nike Air Max', cat: 'Shoes', status: 'Available' },
                    { name: 'Essentials Hoodie', cat: 'Hoodies', status: 'Available' },
                    { name: 'Vintage Tee', cat: 'T-Shirts', status: 'New' },
                    { name: 'Denim Jacket', cat: 'Jackets', status: 'Available' },
                    { name: 'Cargo Pants', cat: 'Pants', status: 'Available' },
                  ].map((item, i) => (
                    <tr key={i} className="border-b border-background-50/5">
                      <td className="py-2.5 px-2 text-sm text-background-50/90">{item.name}</td>
                      <td className="py-2.5 px-2">
                        <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500/20 text-accent-300">{item.cat}</span>
                      </td>
                      <td className="py-2.5 px-2">
                        <span className="text-xs text-accent-300 flex items-center gap-1">
                          <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
                          {item.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}